// extracted by mini-css-extract-plugin
module.exports = {"cardsTitleWrap":"SectionTitleMenu_cardsTitleWrap__tPUNY","cardsControls_mb":"SectionTitleMenu_cardsControls_mb___zdqs"};